import { signInWithCustomToken } from "firebase/auth";

import { auth } from "@/lib/firebase";

/**
 * Dev/test-only auth seam. When the E2E runner plants a Firebase custom
 * token in localStorage before app load, sign in with it so the full real
 * auth path (ID tokens, billing fetch, chat) runs headlessly. Compiled out
 * of production bundles via the NODE_ENV check.
 */
export function maybeSignInForE2E(): void {
  if (process.env.NODE_ENV === "production") return;
  if (typeof window === "undefined") return;
  const token = window.localStorage.getItem("fillapp:e2e-custom-token");
  if (!token || auth.currentUser) return;
  signInWithCustomToken(auth, token)
    .then(() => {
      window.localStorage.removeItem("fillapp:e2e-custom-token");
      // Marker for the E2E runner: only set once the auth state listener has
      // actually propagated (auth.currentUser is populated by then), so a
      // test that waits on this flag can't race the React auth context.
      (window as unknown as { __fillappE2ESignedIn?: boolean }).__fillappE2ESignedIn =
        true;
      console.info("[e2e-auth] signed in with custom token");
    })
    .catch((err) => {
      console.error("[e2e-auth] custom token sign-in failed:", err);
    });
}
